import { RefObject } from 'react';
import useOnScreen from '@/hooks/useOnScreen';

interface BackToTopButtonProps {
  footerRef: RefObject<null | HTMLElement>;
}
const BackToTopButton = ({ footerRef }: BackToTopButtonProps) => {
  const isVisible = useOnScreen(footerRef);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div is="flynt-block-back-to-top" aria-hidden={!isVisible}>
      <button className="button button--filter" onClick={scrollToTop}>
        <i className="icon contents">
          <svg
            width={17}
            height={16}
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.998048 8L2.40805 9.41L7.99805 3.83L7.99805 16L9.99805 16L9.99805 3.83L15.578 9.42L16.998 8L8.99805 -6.99382e-07L0.998048 8Z"
              fill="currentColor"
            />
          </svg>
        </i>
        nach oben
      </button>
    </div>
  );
};

export default BackToTopButton;
